
import * as constants from "../../assets/constants";
import {baseApi} from "../BaseApi";


class EquipmentTypesApi extends baseApi {

    getList = async () => {
        return await this.get('?app=equipmenttypes&act=getList')
    }

}

export default new EquipmentTypesApi(constants.DEBUG?constants.base_url_stage:constants.base_url_prod);

